import React from 'react';
import { motion } from 'framer-motion';

const fadeInUp = {
  initial: { opacity: 0, y: 60 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: "easeOut" }
};

const staggerContainer = {
  initial: "initial",
  whileInView: "animate",
  viewport: { once: true },
  variants: {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  }
};

const faqs = [
  {
    q: "Can I use Webfiny without coding?",
    a: "Yes! Webfiny integrates with no-code platforms like Bubble.io and Zapier, making it accessible to non-developers. Our API documentation also includes guides for easy setup."
  },
  {
    q: "Does Webfiny store my files?",
    a: "No, we prioritize your data privacy. Files are processed in memory and temporarily cached for delivery, then automatically deleted. We do not store your files permanently."
  },
  {
    q: "Can I self-host or white-label?",
    a: "Enterprise plans offer white-label options and can discuss custom deployment solutions for self-hosting. Please contact our sales team for more details."
  },
  {
    q: "How secure are the APIs?",
    a: "Security is paramount. We use token-based authentication (JWT), HTTPS/SSL encryption for all data in transit, and follow industry best practices to ensure your data is protected."
  }
];

const FaqSection = () => {
  return (
    <section id="faq" className="py-20 bg-background border-t border-b border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 font-heading text-primary-foreground">
            Frequently Asked <span className="gradient-text-brand">Questions</span>
          </h2>
        </motion.div>

        <motion.div 
          className="space-y-6"
          {...staggerContainer}
        >
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-card p-6 rounded-xl shadow-xl hover-lift border border-border"
              variants={fadeInUp}
            >
              <h3 className="text-xl font-semibold mb-3 text-card-foreground font-heading">{faq.q}</h3>
              <p className="text-foreground">{faq.a}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FaqSection;